module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\">\r\n    <span class=\"prop-label\">Accessibility</span>\r\n</div>\r\n<div id=\"navSameAsCaption\" class=\"row hide\">\r\n    <label class=\"prop-sublabel\" style=\"margin-left: 15px;\">Same as Caption</label> \r\n</div>\r\n<div id=\"propAccessSilent\"></div>\r\n<div id=\"propAccessDescription\"></div>\r\n<div id=\"propAccessAutoFill\"></div>\r\n<div id=\"propAccessBackgroundPicture\" class=\"prop-detail\"></div>\r\n")
  }
  return __output;

}